export default __webpack_public_path__ + "static/media/applications-image-24.0df6303e.jpg";